// /client/src/pages/LoginPage.js

import React, { useState } from "react";
import {
  Container,
  Paper,
  Box,
  Stack,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import axios from "axios"; // We will use this to make API calls
import { useNavigate } from "react-router-dom"; // ✅ Import this

import { useAuth } from "../context/AuthContext"; // Import useAuth

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const { login } = useAuth(); // Get the login function from context

  const navigate = useNavigate(); // ✅ Call this at the top of the component
  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}/api/auth/login`;
      const response = await axios.post(apiUrl, {
        email,
        password,
      });

      console.log("Login successful:", response.data);
      localStorage.setItem("authToken", response.data.token);

      // ✅ Use React Router navigation
      navigate("/dashboard");
    } catch (err) {
      console.error(
        "Login failed:",
        err.response?.data?.message || "An error occurred"
      );
      setError(
        err.response?.data?.message || "Invalid credentials or server error."
      );
    }
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          padding: 4,
          width: "100%",
          borderRadius: 2,
        }}
      >
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <Stack spacing={2}>
            <Typography component="h1" variant="h5" align="center">
              Admin Login
            </Typography>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {/* Display error message if it exists */}
            {error && (
              <Typography color="error" variant="body2" align="center">
                {error}
              </Typography>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
}
